export default __webpack_public_path__ + "assets/16706ddf25bedd45cecc50901a9c7675.ttf";